'use client'

import { SentenceMakingQuestion } from '@entities/lesson'
import React from 'react'

import { Typography } from '@podo-app/design-system-temp'

type Props = {
  question: SentenceMakingQuestion
  highlightText: (text: string, highlightTarget: string) => React.ReactNode
}

export const SentenceMakingHintFunnel = ({ question, highlightText }: Props) => {
  return (
    <React.Fragment>
      <Typography size="h3" className="font-medium">
        {highlightText(question.source.hint.sentence, question.source.hint.highlight)}
      </Typography>
      <Typography size="body1" className="text-gray-500">
        {question.source.hint.sentence_translation}
      </Typography>
    </React.Fragment>
  )
}
